import { openNewTab } from '../helpers';

export default function mainSlideshow() {
  const widgetName = 'mainSlideshow';
  const widgetOpts = mainSlideshowOpts;
  const $widget = $(`#${widgetName}`);

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      initSwiper(widgetName, response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}

// ======================================================================
// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const { ImageWithPath, ImageAlternateText } = slide;
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${ImageWithPath}" aria-label="${ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

  return template;
}

// ======================================================================
// Slide Template - Slideshows
const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="arrows-container">
        <div class="swiper-button-prev desktop-arrows"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next desktop-arrows"></div>
      </div>
    </div>
    <div class="content-wrap">
      <div class="content-wrap-inner">
        <div class="swiper-container swiper-container-content">
          <div class="swiper-wrapper"></div>
        </div>
      </div>
    </div>  
  `;

// ======================================================================
// Slide Template - Content
function buildSlideTemplateContent(slide) {
  const { Title, URL } = slide;
  const button =
    URL == null
      ? ''
      : `<div class="button-container"><a href="${URL}" class="button" ${openNewTab(URL)}>Buy Now</a></div>`;

  const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="wrap-content-slide">
          <h2 class="slide-title">${Title}</h2>
          </div>
          ${button}
        </div>
      </div>
    `;

  return template;
}

// ======================================================================
// Update Swiper
function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}

// ======================================================================
// Swiper Initialization
function initSwiper(widget, widgetData) {
  const swiperWidgetImagesWrapper = $(`#${widget} .swiper-container-images .swiper-wrapper`);
  const swiperWidgetContentWrapper = $(`#${widget} .swiper-container-content .swiper-wrapper`);

  for (const slide of widgetData) {
    swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
    swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
  }

  const swiperWidgetImages = new Swiper(`#${widget} .swiper-container-images`, {
    speed: 600,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    loop: widgetData.length > 1,
    watchOverflow: true,
    spaceBetween: 0,
    centeredSlides: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  });

  const swiperWidgetContent = new Swiper(`#${widget} .swiper-container-content`, {
    speed: 600,
    spaceBetween: 0,
    centeredSlides: false,
    loop: widgetData.length > 1,
    watchOverflow: true,
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: `#${widget} .swiper-button-next`,
      prevEl: `#${widget} .swiper-button-prev`,
    },
    pagination: {
      el: `#${widget} .swiper-pagination`,
      clickable: true,
    },
  });
  swiperWidgetImages.controller.control = swiperWidgetContent;
  swiperWidgetContent.controller.control = swiperWidgetImages;

  updateSwiper(swiperWidgetImages, swiperWidgetContent);
  customObserver(widget, swiperWidgetImages);
}

// ======================================================================
// Observer to stop autoplay when user is not looking at the slider
function customObserver(widget, swiperWidgetImages) {
  const sliderToObserve = $(`#${widget} .swiper-container-images`).get(0);
  if (sliderToObserve) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            swiperWidgetImages.autoplay.start();
          } else {
            swiperWidgetImages.autoplay.stop();
          }
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(sliderToObserve);
  }
}
